import React from "react";
import {useActiveProjectSelector} from "../store/selectors/project.selectors";
import {useNavigate} from "react-router-dom";
import RouteNameConstants from "../constants/route-name.constants";


function ProjectWrapper(props) {
    const activeProject = useActiveProjectSelector();
    const navigate = useNavigate();
    const Component = props.component;

    React.useEffect(() => {
        if (!activeProject) {
            navigate(`/${RouteNameConstants.CHOOSE_PROJECT}`);
        }
    }, [activeProject, navigate]);

    return(
        <Component />
    )
}

export default ProjectWrapper;
